<div class="secret-key-page">
  @if (!nextPage) {
    <div class="secret-key-component">
      <div class="secret-key-content">
        <form
          #secretKeyForm="ngForm"
          aria-labelledby="secret-key-heading"
          class="secret-key-form"
          (ngSubmit)="secretKeyForm.valid && checkValidity()">
          <div class="secret-key-heading">
            <h1 id="secret-key-heading">
              {{ 'EXTERNAL_PAGE.ACCESS_SHIPMENT' | transloco }}
            </h1>
            <p>{{ 'EXTERNAL_PAGE.SECRET_KEY_HELP' | transloco }}</p>
          </div>
          <label for="secret-key">
            {{ 'EXTERNAL_PAGE.SECRET_KEY' | transloco }}
            <span aria-hidden="true" class="text-red-500">*</span>
          </label>
          <input
            #secretKeyControl="ngModel"
            aria-label="{{ 'EXTERNAL_PAGE.SECRET_KEY' | transloco }}"
            class="secret-input"
            id="secret-key"
            name="secretKey"
            pInputText
            placeholder="{{ 'EXTERNAL_PAGE.ENTER_SECRET_KEY' | transloco }}"
            required
            type="text"
            [attr.aria-describedby]="
              secretKeyError
                ? 'secret-key-feedback'
                : secretKeyControl.touched &&
                    secretKeyControl.hasError('required')
                  ? 'secret-key-required-error'
                  : null
            "
            [attr.aria-invalid]="
              !!secretKeyError ||
              (secretKeyControl.touched && secretKeyControl.invalid)
            "
            [invalid]="
              secretKeyError === 'invalid' ||
              (secretKeyControl.touched && secretKeyControl.invalid)
            "
            (ngModelChange)="secretKeyError = undefined"
            [(ngModel)]="secretKey" />
          @if (
            secretKeyControl.touched && secretKeyControl.hasError('required')
          ) {
            <small
              class="block mt-1 text-red-600"
              id="secret-key-required-error">
              {{ 'EXTERNAL_PAGE.SECRET_KEY_REQUIRED' | transloco }}
            </small>
          }
          @if (secretKeyError) {
            <output
              class="secret-key-notice"
              for="secret-key"
              id="secret-key-feedback">
              <i
                aria-hidden="true"
                [class]="
                  secretKeyError === 'expired'
                    ? 'pi pi-clock'
                    : 'pi pi-info-circle'
                "></i>
              <span>
                <span class="secret-key-notice-title">
                  {{
                    (secretKeyError === 'expired'
                      ? 'EXTERNAL_PAGE.SECRET_KEY_EXPIRED'
                      : 'EXTERNAL_PAGE.SECRET_KEY_INVALID'
                    ) | transloco
                  }}
                </span>
                <span class="secret-key-notice-detail">
                  {{
                    (secretKeyError === 'expired'
                      ? 'EXTERNAL_PAGE.SECRET_KEY_EXPIRED_HELP'
                      : 'EXTERNAL_PAGE.SECRET_KEY_INVALID_HELP'
                    ) | transloco
                  }}
                </span>
              </span>
            </output>
          }
          <button
            class="confirm-btn"
            pButton
            type="submit"
            [disabled]="
              secretKeyForm.invalid ||
              (eventStateService.isVerifyingSecretKeyLoading$ | async)
            ">
            @if (!(eventStateService.isVerifyingSecretKeyLoading$ | async)) {
              {{ 'EXTERNAL_PAGE.CONFIRM' | transloco }}
            } @else {
              <i class="pi pi-spin pi-spinner pr-1"></i>
              {{ 'EXTERNAL_PAGE.LOADING' | transloco }}
            }
          </button>
        </form>
      </div>
      <div class="secret-key-footer">
        {{ 'EXTERNAL_PAGE.POWERED_BY_AGRIDENCE' | transloco }}
      </div>
    </div>
  }
  @if (nextPage) {
    <div class="download-si-component">
      <p-toolbar class="download-toolbar">
        <div class="p-toolbar-group-left">
          <img
            alt="agridence-logo"
            src="../../../assets/images/logo-white.svg" />
        </div>
        <div class="p-toolbar-group-right">
          <button
            class="pi pi-sign-out text-primary-contrast cursor-pointer text-2xl"
            type="button"
            [attr.aria-label]="'EXTERNAL_PAGE.LOGOUT' | transloco"
            (click)="logout()"></button>
        </div>
      </p-toolbar>
      <div class="px-6">
        <h2>{{ 'EXTERNAL_PAGE.DOWNLOAD_SI_INFORMATION' | transloco }}</h2>
        <div class="container p-6 flex flex-col">
          <span class="py-2 text-lg font-medium">
            {{ 'EXTERNAL_PAGE.SI_NUMBER' | transloco }}
            <span>{{ siNumber }}</span>
          </span>
          <button
            class="p-button-success download-btn mt-4 py-4"
            pButton
            (click)="downloadEUDRPackage()">
            @if (
              !(eventStateService.isDownloadingExternalZipFileLoading$ | async)
            ) {
              <i class="pi pi-download pr-2"></i>
              {{ 'EXTERNAL_PAGE.DOWNLOAD_EUDR' | transloco }}
            } @else {
              <i class="pi pi-spin pi-spinner pr-2"></i>
              {{ 'EXTERNAL_PAGE.DOWNLOADING' | transloco }}
            }
          </button>
          <button
            class="p-button-success download-btn mt-4 py-4"
            pButton
            (click)="downloadGeoJsonFiles()">
            @if (
              !(eventStateService.isDownloadingExternalJsonFileLoading$ | async)
            ) {
              <i class="pi pi-download pr-2"></i>
              {{ 'EXTERNAL_PAGE.DOWNLOAD_GEOJSON' | transloco }}
            } @else {
              <i class="pi pi-spin pi-spinner pr-2"></i>
              {{ 'EXTERNAL_PAGE.DOWNLOADING' | transloco }}
            }
          </button>
        </div>
      </div>
    </div>
  }
</div>
